export const GET_BLOCKDATA = 'GET_BLOCKDATA';
export const GET_SPARQL_DATA = 'GET_SPARQL_DATA';
export const GET_DATA_FROM_PROVIDER = 'GET_DATA_FROM_PROVIDER';
export const SET_CONNECTED_DATA_PARAMETERS = 'SET_CONNECTED_DATA_PARAMETERS';
export const DELETE_CONNECTED_DATA_PARAMETERS =
  'DELETE_CONNECTED_DATA_PARAMETERS';
export const CHANGE_SIDEBAR_STATE = 'CHANGE_SIDEBAR_STATE';
export const SET_UNSAVED_CONNECTED_DATA_PARAMETERS =
  'SET_UNSAVED_CONNECTED_DATA_PARAMETERS';

export const DATA_PROVIDER_TYPES = [
  'forests.content.interfaces.IBasicDataProvider',
  'eea.restapi.interfaces.IBasicDataProvider',
];

export const DATACONNECTOR_PARAMS_GROUP = 'DataConnector Parameter';
